import { formatIndiaDate, formatIndiaTime } from './indiaTime';

export const VISIT_STATUS_CLASS = {
  submitted: 'patient-status-submitted',
  cancelled: 'patient-status-cancelled',
  accepted: 'patient-status-accepted',
  completed: 'patient-status-completed',
  expired: 'patient-status-expired',
  paid: 'patient-status-paid',
};

const STATUS_LABELS = {
  submitted: 'Submitted',
  cancelled: 'Cancelled',
  accepted: 'Accepted',
  completed: 'Completed',
  expired: 'Expired',
  paid: 'Paid & Closed',
};

const NON_BLOCKING_DUPLICATE_STATUSES = new Set(['cancelled', 'expired']);

export function formatDisplayDateFromApi(value) {
  return formatIndiaDate(value);
}

export function formatDisplayTimeFromApi(value) {
  return formatIndiaTime(value);
}

const ADDITIONAL_NOTES_MARKER = '\n\nAdditional notes: ';

/** Split stored description back into symptoms + optional notes for editing. */
export function parseVisitDescription(description) {
  if (!description) return { symptoms: '', additionalNotes: '' };
  const idx = description.indexOf(ADDITIONAL_NOTES_MARKER);
  if (idx === -1) {
    return { symptoms: description.trim(), additionalNotes: '' };
  }
  return {
    symptoms: description.slice(0, idx).trim(),
    additionalNotes: description.slice(idx + ADDITIONAL_NOTES_MARKER.length).trim(),
  };
}

/** True if patient already has an active request for same service + slot. */
export function isDuplicateVisitSlot(visits, { serviceTypeId, preferredDateTime, excludeVisitId }) {
  if (!serviceTypeId || !preferredDateTime) return false;

  const slotMs = new Date(preferredDateTime).getTime();
  if (Number.isNaN(slotMs)) return false;

  return visits.some((visit) => {
    if (excludeVisitId != null && String(visit.id) === String(excludeVisitId)) return false;
    if (NON_BLOCKING_DUPLICATE_STATUSES.has(visit.status)) return false;
    if (String(visit.serviceTypeId) !== String(serviceTypeId)) return false;
    const existingMs = new Date(visit.preferredDateTime).getTime();
    return !Number.isNaN(existingMs) && existingMs === slotMs;
  });
}

export function mapVisitFromApi(item) {
  const statusKey = (item.status || '').trim().toLowerCase();
  const rate = item.totalAmount ?? item.totalAMount ?? item.agreedRate ?? 0;

  return {
    id: item.idVisitRequest,
    bookingNumber: item.bookingNumber,
    serviceTypeId: item.serviceTypeID ?? item.serviceTypeId ?? item.ServiceTypeID,
    serviceType: item.serviceTypeName || '—',
    preferredDate: formatDisplayDateFromApi(item.preferredDateTime),
    preferredTime: formatDisplayTimeFromApi(item.preferredDateTime),
    preferredDateTime: item.preferredDateTime,
    amount: Number(rate) > 0 ? `₹${Number(rate).toLocaleString('en-IN')}` : '—',
    status: statusKey,
    statusLabel: STATUS_LABELS[statusKey] || item.status || '—',
    canCancel: item.canCancel === true,
    canEdit: item.canEdit === true || item.canCancel === true,
    description: item.description || '',
    additionalNotes: item.additionalNotes || '',
    cancelReason:
      item.cancelReason || item.CancelReason || item.cancellationReason || '',
  };
}
